// extracted by mini-css-extract-plugin
export default {"dropzone":"folderUpload_dropzone__Xu5m7","browseButton":"folderUpload_browseButton__KTzMl"};